(function () {
  const STORAGE_KEY = 'myzooomy__wishlist';

  const script = document.getElementById('wishlist-count-script');
  const customerId = script && script.dataset.customerId ? script.dataset.customerId : '';
  const shop = script && script.dataset.shop ? script.dataset.shop : '';
  const locale = script && script.dataset.locale ? script.dataset.locale : 'en';
  const isLoggedIn = customerId !== '';

  const WISHLIST_API = 'https://zooomyapps.com/wishlist/api/frontend/wishlist';

  let lastCount = -1;

  function getLocalCount() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return 0;
      const arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.length : 0;
    } catch (e) {
      return 0;
    }
  }

  function paint(count) {
    const nodes = document.querySelectorAll('[data-wishlist-count]');
    if (!nodes.length) return;
    lastCount = count;
    nodes.forEach(function (node) {
      node.textContent = count;
      node.classList.toggle('visible', count > 0);
    });
  }

  function renderLocal() {
    paint(getLocalCount());
  }

  function fetchServerCount() {
    const body = new URLSearchParams({ shop: shop, customerid: customerId, lang: locale });
    fetch(WISHLIST_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    })
      .then(function (res) {

        return res.json().catch(function () {
          return null;
        });
      })
      .then(function (data) {
        if (!data) return;
        let count = 0;
        if (Array.isArray(data.product_id)) count = data.product_id.length;
        else if (Array.isArray(data.id)) count = data.id.length;
        paint(count);
      })
      .catch(function () {});
  }

  let refetchTimer = null;
  function scheduleServerRefresh() {
    if (refetchTimer) clearTimeout(refetchTimer);
    refetchTimer = setTimeout(fetchServerCount, 1500);
  }

  function init() {
    if (isLoggedIn) {
      fetchServerCount();

      document.addEventListener('click', function (e) {
        if (
          e.target.closest('#ZlistWishlist') ||
          e.target.closest('#ZoomyWishlistPage') ||
          e.target.closest('[class*="wishlist"]') ||
          e.target.closest('[class*="oomywish"]')
        ) {
          scheduleServerRefresh();
        }
      });

      window.addEventListener('pageshow', fetchServerCount);
      return;
    }

    renderLocal();

    try {
      const origSetItem = localStorage.setItem;
      localStorage.setItem = function (key, value) {
        origSetItem.apply(this, arguments);
        if (key === STORAGE_KEY) renderLocal();
      };
      const origRemoveItem = localStorage.removeItem;
      localStorage.removeItem = function (key) {
        origRemoveItem.apply(this, arguments);
        if (key === STORAGE_KEY) renderLocal();
      };
    } catch (e) {}

    setInterval(function () {
      if (getLocalCount() !== lastCount) renderLocal();
    }, 1000);

    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) renderLocal();
    });

    window.addEventListener('pageshow', renderLocal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
